import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { initialRootState } from '../initialRootState';
import {
  EThreadActionType,
  EThreadsActionType,
  TThreadAction,
  TThreadsAction,
} from '../threads/actions';
import { EMessagesActionType, TMessagesActions } from './actions';
import { IMessagesEntries } from './types';

export interface IMessagesState {
  entries: IMessagesEntries;
}

export const messagesReducer = (
  currentState: IMessagesState = initialRootState.messages,
  action: TThreadsAction | TMessagesActions | TThreadAction
): IMessagesState => {
  switch (action.type) {
    case EThreadsActionType.GET_SUCCESS:
    case EMessagesActionType.GET_MORE_SUCCESS:
      return {
        ...currentState,
        entries: {
          ...currentState.entries,
          ...action.payload.entities.messages,
        },
      };
    case EThreadActionType.GET_SUCCESS:
      return {
        ...currentState,
        entries: {
          ...currentState.entries,
          ...action.payload.entities.messages,
        },
      };
    case EMessagesActionType.POST_MESSAGE_SUCCESS:
    case EMessagesActionType.NEW_MESSAGE:
      return {
        ...currentState,
        entries: {
          ...currentState.entries,
          [action.payload.id]: action.payload,
        },
      };
    case EMessagesActionType.SET_AS_READ:
      return {
        ...currentState,
        entries: merge({}, currentState.entries, action.payload),
      };
    case EMessagesActionType.DELETE:
      return {
        ...currentState,
        entries: omit(currentState.entries, [action.payload.messageId]),
      };
    default:
      return currentState;
  }
};
